import React from 'react';

export const Checked = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" fill="#3E3E3E" stroke="#3E3E3E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 12L11 14L15 10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const OpenWarning = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`lucide lucide-loader ${props.className}`}
  >
    <path d="M15 4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V20" stroke={props.customstroke ? props.customstroke : '#3E3E3E'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4 20H7" stroke={props.customstroke ? props.customstroke : '#3E3E3E'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15 20H22" stroke={props.customstroke ? props.customstroke : '#3E3E3E'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 12V12.01" stroke={props.customstroke ? props.customstroke : '#3E3E3E'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7 13V20L13.758 21.689C13.9054 21.7258 14.0592 21.7285 14.2078 21.6969C14.3564 21.6653 14.4958 21.6003 14.6155 21.5068C14.7352 21.4133 14.8321 21.2938 14.8987 21.1573C14.9653 21.0208 15 20.8709 15 20.719V4.562C14.9998 4.25818 14.9304 3.9574 14.797 3.68441C14.6637 3.41143 14.4699 3.17241 14.2303 2.98551C13.9908 2.79861 13.7118 2.66874 13.4146 2.60575C13.1174 2.54277 12.8098 2.54832 12.515 2.622L10.515 3.122L9.515 3.372" stroke={props.customstroke ? props.customstroke : '#3E3E3E'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.22833 9.25579L5.895 3.42246C5.82232 3.29421 5.71692 3.18754 5.58955 3.11332C5.46218 3.0391 5.31741 3 5.17 3C5.02259 3 4.87781 3.0391 4.75045 3.11332C4.62308 3.18754 4.51768 3.29421 4.445 3.42246L1.11166 9.25579C1.0382 9.38302 0.999677 9.52742 1 9.67434C1.00033 9.82125 1.03949 9.96548 1.11352 10.0924C1.18755 10.2193 1.29381 10.3244 1.42154 10.397C1.54927 10.4696 1.69392 10.5071 1.84083 10.5058H8.5075C8.65371 10.5056 8.7973 10.467 8.92387 10.3938C9.05043 10.3206 9.15551 10.2154 9.22854 10.0888C9.30158 9.9621 9.34001 9.81845 9.33998 9.67224C9.33994 9.52603 9.30144 9.38241 9.22833 9.25579Z" stroke={props.customstroke ? props.customstroke : '#3E3E3E'} strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.17419 5.5058V7.17246" stroke={props.customstroke ? props.customstroke : '#3E3E3E'} strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.17419 8.83913H5.17794" stroke={props.customstroke ? props.customstroke : '#3E3E3E'} strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const Auction = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`lucide lucide-loader ${props.className}`}
  >
    <path
      fill={props.customstroke ? props.customstroke : '#3E3E3E'}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.24265 9.65684L8.24263 9.65685C7.8521 10.0474 7.21894 10.0474 6.82842 9.65685C6.43789 9.26633 6.43789 8.63316 6.82842 8.24264L11.7782 3.29289C12.1687 2.90237 12.8019 2.90237 13.1924 3.29289C13.5829 3.68342 13.5829 4.31658 13.1924 4.70711L16.0209 7.53554L16.728 6.82843C17.1185 6.43791 17.7517 6.43791 18.1422 6.82843C18.5327 7.21896 18.5327 7.85212 18.1422 8.24264L17.4351 8.94975L20.2635 11.7782C20.654 11.3876 21.2871 11.3876 21.6777 11.7782C22.0682 12.1687 22.0682 12.8019 21.6777 13.1924L20.9753 13.8947C20.9738 13.8963 20.9722 13.8979 20.9706 13.8995L17.4351 17.435C17.4335 17.4366 17.4319 17.4382 17.4303 17.4398L16.7279 18.1421C16.3374 18.5327 15.7042 18.5327 15.3137 18.1421C14.9232 17.7516 14.9232 17.1184 15.3137 16.7279L12.4853 13.8995L4.70711 21.6777C4.31658 22.0682 3.68342 22.0682 3.29289 21.6777C2.90237 21.2871 2.90237 20.654 3.29289 20.2635L11.0711 12.4853L8.24265 9.65684ZM16.7279 15.3137L18.8493 13.1924L11.7782 6.12132L9.65688 8.24264L16.7279 15.3137Z"/>
  </svg>
)

export const Unlocked24 = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z" stroke="#3E3E3E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M7 11V7C6.99876 5.76005 7.45828 4.56387 8.28938 3.64367C9.12047 2.72347 10.2638 2.1449 11.4975 2.02029C12.7312 1.89568 13.9671 2.2339 14.9655 2.96931C15.9638 3.70472 16.6533 4.78485 16.9 6" stroke="#3E3E3E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const Unlocked20 = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path stroke={props.customstroke ? props.customstroke : '#3E3E3E'} d="M15.8333 9.16666H4.16667C3.24619 9.16666 2.5 9.91286 2.5 10.8333V16.6667C2.5 17.5871 3.24619 18.3333 4.16667 18.3333H15.8333C16.7538 18.3333 17.5 17.5871 17.5 16.6667V10.8333C17.5 9.91286 16.7538 9.16666 15.8333 9.16666Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path stroke={props.customstroke ? props.customstroke : '#3E3E3E'} d="M5.83332 9.16666V5.83333C5.83228 4.80004 6.21522 3.80322 6.90779 3.03639C7.60037 2.26955 8.55317 1.78742 9.58124 1.68357C10.6093 1.57973 11.6393 1.86158 12.4712 2.47443C13.3031 3.08727 13.8777 3.98737 14.0833 5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const Noke = (props) => (
  <svg {...props} width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="24" fill="#009DE0"/>
    <path d="M29.8244 30.5317L27.4335 30.5317L27.4335 22.5749C27.4335 22.1158 27.4144 21.6504 27.3761 21.1786C27.3251 20.7068 27.1976 20.2796 26.9936 19.8971C26.7768 19.5273 26.458 19.2212 26.0372 18.979C25.6037 18.7367 24.998 18.6156 24.2201 18.6156C23.4423 18.6156 22.843 18.7367 22.4222 18.979C21.9887 19.2212 21.6699 19.5273 21.4659 19.8971C21.2491 20.2796 21.1216 20.7068 21.0833 21.1786C21.0323 21.6504 21.0068 22.1158 21.0068 22.5749L21.0068 30.5317L18.6159 30.5317L18.6159 21.7906C18.6159 20.9108 18.7498 20.1457 19.0176 19.4954C19.2854 18.8451 19.6679 18.2968 20.1652 17.8505C20.6498 17.4169 21.2363 17.0918 21.9249 16.875C22.6135 16.6582 23.3786 16.5498 24.2201 16.5498C25.0617 16.5498 25.8268 16.6582 26.5154 16.875C27.204 17.0918 27.7969 17.4169 28.2942 17.8505C28.7788 18.2968 29.1549 18.8451 29.4227 19.4954C29.6905 20.1457 29.8244 20.9108 29.8244 21.7906L29.8244 30.5317Z" fill="white"/>
  </svg>
)

export const Loader20 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={`lucide lucide-loader ${props.className}`}>
    <path d="M12 2v4" stroke="black" />
    <path d="m16.2 7.8 2.9-2.9" stroke="#F5F5F5" />
    <path d="M18 12h4" stroke="#E7E7E7" />
    <path d="m16.2 16.2 2.9 2.9" stroke="#B6B6B6" />
    <path d="M12 18v4" stroke="#999999" />
    <path d="m4.9 19.1 2.9-2.9" stroke="#7D7D7D" />
    <path d="M2 12h4" stroke="#646464" />
    <path d="m4.9 4.9 2.9 2.9" stroke="#3E3E3E" />
  </svg>
)

export const TenantIcon = () => (
  <svg width="104" height="88" viewBox="0 0 104 88" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M96 17C119.501 30.3529 83.1803 88 43 88C26.5067 88 0 63.5079 0 45.3732C0 27.2385 10.5067 17 27 17C54 17 52 -8 96 17Z" fill="#EBF9FF"/>
    <path d="M49 39C57.2843 39 64 32.2843 64 24C64 15.7157 57.2843 9 49 9C40.7157 9 34 15.7157 34 24C34 32.2843 40.7157 39 49 39Z" stroke="#0094CC" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M73 63C73 56.6348 70.4714 50.5303 65.9706 46.0294C61.4697 41.5286 55.3652 39 49 39C42.6348 39 36.5303 41.5286 32.0294 46.0294C27.5286 50.5303 25 56.6348 25 63" stroke="#0094CC" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const EmployeeIcon = () => (
  <svg
    width="104"
    height="88"
    viewBox="0 0 104 88"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="rotate(180, 52, 44)">
      <path
        d="M96 17C119.501 30.3529 83.1803 88 43 88C26.5067 88 0 63.5079 0 45.3732C0 27.2385 10.5067 17 27 17C54 17 52 -8 96 17Z"
        fill="#EBF9FF"
      />
    </g>
    <g transform="translate(13, 0) scale(3.5)">
      <rect
        x="3"
        y="4"
        width="18"
        height="14"
        rx="2"
        stroke="#0094CC"
        strokeWidth="1.5"
      />
      <path
        d="M9 11l2 2 4-4"
        stroke="#0094CC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 20V19"
        stroke="#0094CC"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9 21h6"
        stroke="#0094CC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const VendorIcon = () => (
  <svg width="93" height="85" viewBox="0 0 93 85" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M82.5324 39.6269C108.595 46.791 82.5324 85 42.3522 85C25.8589 85 0 68.5079 0 50.3731C0 32.2384 8.48365 5 24.9769 5C72.7588 5 34.7505 26.4925 82.5324 39.6269Z" fill="#EBF9FF"/>
    <path d="M35 30V15C35 14.2044 35.3161 13.4413 35.8787 12.8787C36.4413 12.3161 37.2044 12 38 12H44C44.7956 12 45.5587 12.3161 46.1213 12.8787C46.6839 13.4413 47 14.2044 47 15V30" stroke="#0094CC" strokeWidth="4.8" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M47 18C51.7739 18 56.3523 19.8964 59.7279 23.2721C63.1036 26.6477 65 31.2261 65 36V45" stroke="#0094CC" strokeWidth="4.8" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M17 45V36C17 31.2261 18.8964 26.6477 22.2721 23.2721C25.6477 19.8964 30.2261 18 35 18" stroke="#0094CC" strokeWidth="4.8" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M68 45H14C12.3431 45 11 46.3431 11 48V54C11 55.6569 12.3431 57 14 57H68C69.6569 57 71 55.6569 71 54V48C71 46.3431 69.6569 45 68 45Z" stroke="#0094CC" strokeWidth="4.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const CaughtUp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="90" height="85" viewBox="0 0 90 85" fill="none">
    <path opacity="0.5" d="M84 8.84977C99.9844 30.6465 83.1803 84.8514 43 84.8514C26.5067 84.8514 0 60.3592 0 42.2245C0 24.0898 10.5067 13.8514 27 13.8514C54 13.8514 67.5 -13.6501 84 8.84977Z" fill="#CCF1FF"/>
    <path d="M71.0528 39.3498C72.0804 44.3928 71.3481 49.6355 68.978 54.2039C66.6079 58.7722 62.7433 62.3899 58.0287 64.4538C53.3141 66.5176 48.0345 66.9028 43.0703 65.5452C38.106 64.1875 33.7573 61.169 30.7492 56.993C27.7412 52.8171 26.2556 47.7361 26.5403 42.5974C26.8251 37.4588 28.8628 32.573 32.3138 28.755C35.7648 24.9369 40.4204 22.4173 45.5042 21.6164C50.5881 20.8154 55.7929 21.7815 60.2506 24.3536" stroke="#0094CC" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M42.25 41.5999L49 48.3499L71.5 25.8499" stroke="#0094CC" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const ImageIcon = () => (
    <svg width="105" height="104" viewBox="0 0 105 104" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect opacity="0.6" x="0.5" y="8" width="96" height="96" rx="12" fill="#CCF1FF" />
        <rect x="10.5" y="2" width="92" height="92" rx="12" stroke="#E7E7E7" strokeWidth="4" />
        <path
            d="M36.6378 45.6087L26.6438 57.4582C25.7963 58.4631 26.5106 60 27.8252 60H84.5919C85.9929 60 86.671 58.2853 85.6489 57.3271L63.957 36.9909C63.3625 36.4336 62.4375 36.4336 61.843 36.9909L46.8903 51.0091C46.2959 51.5664 45.3708 51.5664 44.7763 51.0091L38.8761 45.4776C38.2302 44.8721 37.2086 44.9319 36.6378 45.6087Z"
            stroke="#999999"
            strokeWidth="3.09091"
            strokeLinejoin="round"
        />
        <circle cx="47.5" cy="36" r="6" fill="#00ADEE" />
    </svg>
);
